export default {"mode":"md"}